import imageOnboarding1 from '../../assets/image-onboarding-1.webp';
import { ProgressIndicators } from '../progress-indicators';
import { OnboardingContinueButton } from '../onboarding-continue-button';
import { OnboardingScreen } from '../onboarding-layout';

interface Step2Props {
  onContinue: () => void;
}

export function OnboardingStep2({ onContinue }: Step2Props) {
  return (
    <OnboardingScreen
      slot="onboarding-step-2"
      header={
        <div className="flex w-full flex-col items-center gap-3">
          <ProgressIndicators currentStep={1} />

          <div className="w-full text-center">
            <h1 className="font-display text-[28px] font-bold leading-9 text-mf-neutral-900">
              Thousands of active settlements — checking yours takes a few clicks
            </h1>
            <p className="mt-2 text-base leading-5 text-mf-neutral-600">
              No lawyers, no paperwork — just a couple minutes and we handle the rest.
            </p>
          </div>
        </div>
      }
      footer={<OnboardingContinueButton onClick={onContinue} />}
    >
      <div className="flex min-h-0 w-full flex-1 flex-col justify-center">
        <div className="mx-auto flex min-h-0 w-full max-w-[394px] flex-1 flex-col justify-center max-h-[320px]">
          <img
            src={imageOnboarding1}
            alt=""
            className="h-full min-h-0 w-full object-contain object-bottom"
          />
        </div>
      </div>
    </OnboardingScreen>
  );
}
